import { Meta } from '@weblite-wapps/protocol'
import { generateWappElementName } from 'weblite-web-wapprunner'
import { asyncDelay } from '$func/delay'

export const getWappDOMElement = async (
  meta: Meta,
  retryCount = 0,
): Promise<HTMLIFrameElement | null> => {
  if (retryCount > 5) return null
  const elements = window.document.getElementsByName(
    generateWappElementName(meta),
  )

  if (elements.length > 0) return elements[0] as HTMLIFrameElement

  await asyncDelay(50)
  return getWappDOMElement(meta, retryCount + 1)
}

export const postMessage = (element: HTMLIFrameElement, action: unknown) => {
  // TODO: Change targetOrigin only for wappDevEnv
  element.contentWindow?.postMessage(JSON.stringify(action), '*')
}
